// extracted by mini-css-extract-plugin
export default {"form":"styles_form__vUZCB","button":"styles_button__WnjnC","return":"styles_return__hHemG"};